// components/PriceInfo.tsx
import React from "react";
import Row from "@components/row";
import Fields from "@components/fields";
import FieldWrapper from "@components/wrapper/field-wrapper";
import Typography from "@components/typography";
import DateTimePicker from "@components/fields/datetime";

interface PriceInfoProps {
  values: any;
  disabled?: boolean;
}

export const PriceInfo: React.FC<PriceInfoProps> = ({ values, disabled = false }) => {
  const discountTypeOptions = [
    { id: 1, key: "Percentage" },
    { id: 2, key: "Amount" },
  ];

  return (
    <FieldWrapper styleWrapper="width:98%">
      <Typography styleText="font-size:16px;font-weight:600;margin-bottom:10px">
        Price Information
      </Typography>
      <br />
      <Row styleRow="row-gap:10px">
        <Fields.Input
          name="price"
          label="Price"
          placeholder="Enter Price"
          disabled={disabled}
        />
        <Fields.DropDown
          name="discountType"
          label="Discount Type"
          options={discountTypeOptions}
          placeholder="Percentage/Amount"
          styleInput="width:96%"
          titleAsKey="key"
          valueAsKey="id"
          disabled={disabled}
        />
        <Fields.Input
          name="discount"
          label="Discount"
          placeholder="Enter Discount"
          disabled={disabled}
        />
      </Row>
      <br />
      <Row styleRow="row-gap:10px">
        <Fields.DropDown
          name="discountAvailabilty"
          label="Discount Availability"
          options={[
            { id: 1, name: "Always" },
            { id: 2, name: "Custom Duration" },
          ]}
          placeholder="discountAvailability"
          styleInput="width:96%"
          titleAsKey="name"
          valueAsKey="id"
          disabled={disabled}
        />
        <DateTimePicker
          disabled={disabled || values.discountAvailabilty === "1"}
          name="discountstartdate"
          label="Discount Start Date"
          placeholder="Select Date"
          timeFormat="hh:mm aa"
          timeIntervals={15}
        />
        <DateTimePicker
          disabled={disabled || values.discountAvailabilty === "1"}
          name="discountenddate"
          label="Discount End Date"
          placeholder="Select Date"
          timeFormat="hh:mm aa"
          timeIntervals={15}
        />
      </Row>
    </FieldWrapper>
  );
};
